module.exports = __webpack_public_path__ + "img/edge_hebergements_hotel.0ea40122.svg";